
class ProductSticky
extends HTMLElement {

    #onVariant
    #form

    connectedCallback (){

        this.#form = document.getElementById
            ( this.getAttribute('form-id') )

        this.#onVariant = this
            ._onVariantChanged.bind(this)

        this.#form?.addEventListener
            ( 'Variant:Changed' , this.#onVariant )

        this._setupVisibilityObservers()
    }

    disconnectedCallback (){
        this.intersectionObserver.disconnect()
        this.#form?.removeEventListener('Variant:Changed',this.#onVariant)
    }

    set hidden ( value ){

        this.toggleAttribute('hidden',value)

        const height = ( value ) ? 0 : this.clientHeight

        document.documentElement.style.setProperty
            ( '--cart-notification-offset' , `${ height }px` )
    }

    async _onVariantChanged (){

        const { sectionId } = this.dataset

        const url = new URL(window.location)
        url.searchParams.set('section_id',sectionId)

        const response = await fetch(url)

        const html = await response.text()

        const parser = new DOMParser()

        const dom = parser.parseFromString(html,'text/html')

        const sticky = dom.querySelector(`product-sticky`)

        this.replaceWith(sticky)
    }

    _setupVisibilityObservers() {

        const
            paymentContainerElement = document.getElementById("MainPaymentContainer"),
            footerElement = document.querySelector(".shopify-section--footer") ,
            stickyHeaderOffset = getStickyHeaderOffset();

        this._isFooterVisible = this._isPaymentContainerPassed = false;

        this.intersectionObserver = new IntersectionObserver((entries) => {

            entries.forEach((entry) => {

                if( entry.target === footerElement )
                    this._isFooterVisible = entry.intersectionRatio > 0;

                if( entry.target === paymentContainerElement ){
                    const boundingRect = paymentContainerElement.getBoundingClientRect();
                    this._isPaymentContainerPassed = entry.intersectionRatio === 0 && boundingRect.top + boundingRect.height <= stickyHeaderOffset;
                }
            });

            if (window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
                this.hidden = !this._isPaymentContainerPassed || this._isFooterVisible;
            } else {
                this.hidden = !this._isPaymentContainerPassed;
            }
        }, {
            rootMargin: `-${stickyHeaderOffset}px 0px 0px 0px`
        });

        this.intersectionObserver.observe(paymentContainerElement);
        this.intersectionObserver.observe(footerElement);
    }
}


window.customElements.define(
    'product-sticky' ,
    ProductSticky
)
